export default "__VITE_ASSET__7f86320d__"